import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="max-w-md mx-auto px-4 py-28 text-center" data-testid="not-found-page">
      <p className="font-heading text-6xl font-bold text-primary">404</p>
      <h1 className="mt-4 font-heading text-2xl font-semibold">Halaman tidak ditemukan</h1>
      <p className="mt-2 text-sm text-muted-foreground">Halaman yang kamu cari tidak tersedia.</p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-6 inline-block px-6 py-3 rounded-full bg-accent text-accent-foreground font-semibold hover:scale-105 transition-transform"
      >
        Kembali ke Beranda
      </Link>
    </div>
  );
}
